export function replaceAntiForgeryToken(callback?: () => void) {
    fetch('/umbraco/api/AntiforgeryTokenApi/GetToken', {
        credentials: 'include'
    })
    .then(res => res.json())
    .then(({ token, field }) => {
        document.querySelectorAll<HTMLInputElement>(`input[name="${field}"]`).forEach(input => {
            input.value = token;
        });
		if (callback) {
            callback(); // 🔁 call the callback after replacement
        }
    })
    .catch(err => {
        console.error("Failed to replace anti-forgery token:", err);
    });
}
